import { render, staticRenderFns } from "./UIIcons.vue?vue&type=template&id=edf8c9a6"
import script from "./UIIcons.vue?vue&type=script&lang=js"
export * from "./UIIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports